// extracted by mini-css-extract-plugin
export default {"itemsContainer":"List_itemsContainer__EaP1f t-12 t-m-16 t-l-8 t-xl-16 b-40 b-m-60 b-l-120","items":"List_items__RksZo row l-2 r-2","card":"List_card__5N6+8"};